import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {WidgetCheckboxV0NodeDto} from "../models/widget-checkbox-v0-node.dto";
import {ColumnApi, GridApi} from "ag-grid-community";

@Component({
  selector: 'pt-widget-checkbox-v0-select',
  templateUrl: './widget-checkbox-v0-select.component.html',
  styleUrls: ['./widget-checkbox-v0-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WidgetCheckboxV0SelectComponent implements OnChanges {
  @Input() checkbox: WidgetCheckboxV0NodeDto[];
  @Output() changeSelectedRowId = new EventEmitter<string[]>();

  public gridApi: GridApi;
  public columnApi: ColumnApi;
  public rowData: SelectCheckboxData[] = [];
  public selectedRowUUID: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.populateTable();
  }

  changeSelectedRow($event: string[]) {
    const selectedUUID: string[] = $event;
    this.changeSelectedRowId.emit(selectedUUID);
  }

  private populateTable() {
    this.selectedRowUUID = [];
    const data: SelectCheckboxData[] = [];
    this.checkbox.forEach(root => {
      root.children.forEach(children => {
        data.push({
          uuid: children.uuid,
          label: children.label,
          help: children.help,
          checked: children.checked
        })
        if (children.checked) {
          this.selectedRowUUID.push(children.uuid);
        }
      })
    })
    this.rowData = data;
  }
}

interface SelectCheckboxData {
  uuid: string;
  label: string;
  help: string;
  checked: boolean;
}
